import React from 'react';
import { Hero } from './components/Hero';
import { Problem } from './components/Problem';
import { WhyFailed } from './components/WhyFailed';
import { Mechanism } from './components/Mechanism';
import { WhatYouGet } from './components/WhatYouGet';
import { ForWhom } from './components/ForWhom';
import { HowItWorks } from './components/HowItWorks';
import { Proof } from './components/Proof';
import { FAQ } from './components/FAQ';
import { Offer } from './components/Offer';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-cream selection:bg-terracotta/20" data-id="element-0">
      <Hero data-id="element-1" />
      <Problem data-id="element-2" />
      <WhyFailed data-id="element-3" />
      <Mechanism data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <ForWhom data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <Proof data-id="element-8" />
      <FAQ data-id="element-9" />
      <Offer data-id="element-10" />
      <Footer data-id="element-11" />
    </div>;
}